import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";
import { API } from "../../API";
import { isAutheticated } from "../auth/authhelper";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const { token } = isAutheticated();

    const [userData, setUserData] = useState(null);
    const [adminLogo, setAdminLogo] = useState("");
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchData = async () => {
            if (!token) {
                setLoading(false);
                return;
            }
            try {
                const res = await axios.get(`${API}/api/user`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.data?.data) {
                    setUserData(res.data?.data);
                    if (res.data.data.picture !== "") {
                        setAdminLogo(res.data.data.picture);
                    }
                }
            } catch (err) {
                console.error("Failed to fetch user:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [token, API]);

    return (
        <UserContext.Provider value={{ userData, setUserData, adminLogo, setAdminLogo, loading }}>
            {children}
        </UserContext.Provider>
    );
};

export const useUser = () => useContext(UserContext);
